import axios from "axios";
import API_ROUTE from "../utils/apiRoute";
import keycloak from "../auth/keycloak";

const http = axios.create({
  baseURL: API_ROUTE,
  // keep cookies if your backend still uses them for session or extra logic
  withCredentials: true,
});

http.interceptors.request.use(async (config) => {
  if (keycloak.authenticated) {
    try {
      await keycloak.updateToken(30);
    } catch (e) {
      // ignore
    }
    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
  }
  return config;
});

export default http;
